<script setup lang="ts">
    interface CartButtonProps {
        id: string;
    }
    defineProps<CartButtonProps>();

    const nuxtApp = useNuxtApp();
    const route = useRoute();
    const cartStore = useCartStore();
    const { cartStatus, checkout } = storeToRefs(cartStore);
    const { openCartDrawer } = useCart();

    const cartReady = computed(() => cartStatus.value === 'ready');
    const isCartPage = computed(() => route.path.includes('/cart'));

    const handleOpenCartDrawer = () => {
        openCartDrawer();
        nuxtApp.$gtm.viewCart(checkout.value);
    };
</script>
<template>
    <div :class="['atm-cart-button relative transition-opacity', { 'opacity-60': !cartReady }]">
        <atm-cart-items-bubble />
        <nuxt-link
            v-if="isCartPage"
            to="#main"
            aria-current="page"
            :aria-label="$t('cart.base')"
            :class="[
                'flex h-12 w-12 transition-colors lg:h-10 lg:w-10',
                { 'hover:text-woom-red': cartReady && !isCartPage, 'pointer-events-none text-woom-red': isCartPage },
            ]"
            :id="id">
            <woom-icon-cart class="m-auto h-6 w-6 fill-current" />
        </nuxt-link>

        <button
            v-else
            :aria-label="$t('cta.cart.openDrawer')"
            :class="['flex h-12 w-12 transition-colors lg:h-10 lg:w-10', { 'hover:text-woom-red': cartReady && !isCartPage }]"
            :disabled="!cartReady"
            :id="id"
            @click="handleOpenCartDrawer">
            <woom-icon-cart class="m-auto h-6 w-6 fill-current" />
        </button>
    </div>
</template>
